module.exports = __webpack_public_path__ + "img/grid_icon.14efb1d1.png";